import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

// `?embed=1` (set by profiles/profile.php's iframe src) flips us into a
// tightened layout that fits the legacy 465×340 profile-chat box.
try {
    if (new URLSearchParams(window.location.search).get('embed') === '1') {
        document.body.classList.add('pc-embedded');
    }
} catch { /* SSR / test guard */ }

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');
createRoot(root).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
